var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 64,
    viewBox: "0 0 67 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6017 15.7379C40.6493 14.7576 39.1009 14.7533 38.1435 15.7294C34.7393 19.2004 27.2302 26.8566 23.9984 30.1518C23.1529 31.0136 23.1462 32.4129 23.9834 33.2832C27.3479 36.779 35.3982 45.1442 38.5646 48.4352C38.9119 48.7961 39.3844 48.9991 39.8784 49C40.3725 49.0017 40.8466 48.8003 41.1947 48.442C41.3821 48.2491 41.5752 48.0503 41.7642 47.8558C42.555 47.0418 42.5591 45.7261 41.7725 44.907C38.9352 41.9513 32.6247 35.3797 30.1372 32.7892C29.5644 32.1928 29.5702 31.2329 30.1496 30.6433C32.5941 28.1569 38.6823 21.9632 41.5926 19.0025C42.017 18.5707 42.2557 17.9846 42.2582 17.3728C42.2599 16.7601 42.0236 16.1723 41.6026 15.7388C41.6017 15.738 41.6017 15.7379 41.6017 15.7379Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/Back_Arrow.444f0541b40333fd0766ed9323586232.svg";
export { ForwardRef as ReactComponent };